/**
 * TemplateCreator's API, as the browser sees it. Reuses api.ts's BASE/json/postJson/ApiError -
 * same reasoning as speclens-api.ts, both clients hit the same Lambda.
 */

import type { BuildRequest, BuildResponse, ProjectFacts } from "@plan-forge/templatecreator-contract";
import { postJson, type AuthHeaders } from "./api.ts";

const NO_AUTH: AuthHeaders = async () => ({});

export async function buildManifest(
  projectFacts: ProjectFacts,
  auth: AuthHeaders = NO_AUTH,
): Promise<BuildResponse> {
  return postJson<BuildResponse>("/templatecreator/build", { projectFacts } satisfies BuildRequest, auth);
}
